import { ROUTES } from '../../../../Routes';
import * as React from 'react';
import PageConfig from '../../../../services/userflow/PageConfig';
import { ErrorFlow } from '../../pages/error/ErrorFlow';
import { AuthCard } from '../../../../components/Card';
import { EnterUsernameForm } from '../../pages/enter-username/EnterUsernameForm';
import { CaptchaSection } from '../../pages/enter-username/sub-components/CaptchaSection';
import RegisterClipboard from 'images/register_clipboard.svg';
import { navigateToErrorPageFromForgotPassword } from '../../pages/error/ErrorNavigation';
import { History } from 'history';
import { Page } from '../../../../components/Page';

interface ForgotPasswordEnterUsernamePageProps {
  history: History;
  location: Location;
}

const nextAction = (history: any) => (urlParams: string) => {
  history.push(`${ROUTES.RESET_PASSWORD_ONE_TIME_CODE}?${urlParams}`);
};

const pageConfig = {
  errorType: ErrorFlow.resetPassword,
  startRoute: ROUTES.RESET_PASSWORD_ENTER_USERNAME,
  analytics: { pageName: 'forgot-password', taskName: 'forgot-password-new' },
} as PageConfig;

const ForgotPasswordEnterUsernamePage: React.FC<ForgotPasswordEnterUsernamePageProps> = ({
  history,
  location,
}) => {
  return (
    <Page>
      <AuthCard image={RegisterClipboard}>
        <>
          <EnterUsernameForm
            history={history}
            location={location}
            nextAction={nextAction(history)}
            config={pageConfig}
            navigateToErrorPage={navigateToErrorPageFromForgotPassword(history)}
            infoText={'Enter the email address linked to your account'}
          />
          <CaptchaSection />
        </>
      </AuthCard>
    </Page>
  );
};

export { ForgotPasswordEnterUsernamePage };
